import { ToolbarWrapper as ToolbarWrapperOld } from '@atlassian/jira-floating-toolbar/src/ui/toolbar-wrapper/index.tsx';
import {
	ToolbarWrapper as ToolbarWrapperNew,
	ToolbarSkeleton as ToolbarSkeletonNew,
} from '@atlassian/platform-floating-toolbar';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { fg } from '@atlassian/jira-feature-gating';
import { ToolbarSkeleton as ToolbarSkeletonOld } from '@atlassian/jira-floating-toolbar/src/ui/skeleton/index.tsx';

export const ToolbarWrapper = componentWithCondition(
	() => fg('migrate_to_platform_bulk_toolbar'),
	ToolbarWrapperNew,
	ToolbarWrapperOld,
);

export const ToolbarSkeleton = componentWithCondition(
	() => fg('migrate_to_platform_bulk_toolbar'),
	ToolbarSkeletonNew,
	ToolbarSkeletonOld,
);
